/* eslint-disable */ import { attributeSelectionComponent, memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { BurnerBaseW24Variant } from '../model/index.js';
export const burnerBaseW24Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('BurnerBaseW24').attach(memoEval((self)=>[
            self.$bodyObjectName
        ], ($bodyObjectName)=>({
            fileUrl: '/models/jms.glb',
            objectName: $bodyObjectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(attributeSelectionComponent, 'variant', true).withEntity('BurnerBaseW24').attach(memoEval((self)=>[
            self.variant
        ], (variant)=>({
            value: variant,
            options: [
                {
                    label: 'Countertop height',
                    value: 'CounterTopHeight'
                },
                {
                    label: 'Recessed',
                    value: 'Lowered'
                }
            ]
        })), (state)=>{
        BurnerBaseW24Variant.assert(state.value);
        return {
            variant: state.value
        };
    })
];

//# sourceMappingURL=burner-base-w-24.js.map